import ColorUtil from "../../app/utils/ColorUtil";

export default class BackgroundClassUtil {

    constructor() {
        this.colorNames = new ColorUtil().tailwindBrightColors()
    }

    lightClasses(colorName) {
        return `bg-${colorName}-100 hover:bg-${colorName}-200 text-${colorName}-600`
    }
    whiteClasses(colorName) {
        return `bg-white hover:bg-${colorName}-200 text-${colorName}-500`
    }
    brightClasses(colorName) {
        return `bg-${colorName}-500 hover:bg-${colorName}-600 text-white`
    }
    darkClasses(colorName) {
        return `bg-${colorName}-950 hover:bg-${colorName}-800 text-${colorName}-50`
    }
    neutralDarkClasses(colorName) {
        return `bg-${colorName}-700 hover:bg-${colorName}-600 text-${colorName}-50`
    }
    gradientClasses(colorName) {
        return `from-${colorName}-500 to-${colorName}-700 hover:from-${colorName}-600 hover:to-${colorName}-800 text-white`
    }
    darkGradientClasses(colorName) {
        return `from-${colorName}-900 to-${colorName}-950 hover:from-${colorName}-700 hover:to-${colorName}-800 text-${colorName}-300`
    }
    twoColorGradientClasses(colorName, index) {
        let nextIndex = index === (this.colorNames.length - 1) ? 0 : index + 1
        let nextColor = this.colorNames[nextIndex]
        return `from-${colorName}-500 to-${nextColor}-500 hover:from-${colorName}-600 hover:to-${nextColor}-600 text-white`
    }
    threeColorGradientClasses(colorName, index) {
        let nextIndex = this.nextIndex(index)
        let nextColor = this.colorNames[nextIndex]

        let index3 = this.nextIndex2(index)
        let color3 = this.colorNames[index3]
        return `from-${colorName}-500 via-${nextColor}-500 to-${color3}-500 hover:from-${color3}-500 hover:via-${nextColor}-500 hover:to-${colorName}-500 text-white`
    }
    threeColorGradientClasses2(colorName, index) {
        let nextIndex = this.plus2(index)
        let nextColor = this.colorNames[nextIndex]

        let index3 = this.plus4(index)
        let color3 = this.colorNames[index3]
        return `from-${colorName}-600 via-${nextColor}-600 to-${color3}-600 hover:from-${color3}-500 hover:via-${nextColor}-500 hover:to-${colorName}-500 text-white`
    }
    darkThreeColorGradientClasses2(colorName, index) {
        let nextIndex = this.plus2(index)
        let nextColor = this.colorNames[nextIndex]

        let index3 = this.plus4(index)
        let color3 = this.colorNames[index3]
        return `from-${colorName}-900 via-${nextColor}-900 to-${color3}-900 hover:from-${color3}-800 hover:via-${nextColor}-800 hover:to-${colorName}-800 text-white`
    }
    plus2(index) {
        return (index + 2) % this.colorNames.length
    }
    plus4(index) {
        return (index + 5) % this.colorNames.length
    }
    nextIndex(index) {
        return (index + 1) % this.colorNames.length
    }
    nextIndex2(index) {
        return this.plus2(index)
    }
}